import React, {Fragment} from 'react';

import {ErrorState, MainHeader} from 'presentation/components';
import {translations} from 'presentation/translations-new';
import {OdontoBookingTaggingEnum} from 'main/analytics/gaTagsEnum';
import {StyledContainer} from './styles';
import {BookingErrorStateProps} from './types';

const {pleaseTryAgain} = translations['pt-br'].commons;

export function BookingErrorState({
	pageTitle,
	handleBack,
	handleRefresh,
	errorTitle,
	children,
	showHeader = true,
}: BookingErrorStateProps) {
	return (
		<Fragment>
			{showHeader ? (
				<MainHeader
					title={pageTitle}
					handleBack={handleBack}
					handleClose={handleBack}
					variant="subRoute"
				/>
			) : null}
			<StyledContainer>
				<ErrorState
					containerDataTagId={
						OdontoBookingTaggingEnum.ERRO_NAO_FOI_POSSIVEL_LISTAR_UNIDADES
					}
					buttonDataTagId={OdontoBookingTaggingEnum.CLICK_TENTAR_NOVAMENTE_ERRO_UNIDADES}
					title={errorTitle}
					description={pleaseTryAgain}
					handleRefresh={handleRefresh}>
					{children}
				</ErrorState>
			</StyledContainer>
		</Fragment>
	);
}
